import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormTabPane,
  title: 'Form Tab Pane',
  category: ComponentCategory.FormControls,
  droppable: true,
  showInLibrary: false,
};
